// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"link-module__currentPage___1m8uX"};